/** API publica del asistente de citas (sin JWT). */

export type ClinicaPublicaInfo = {
  tenantId: string;
  nombre: string;
  edicion?: string;
  tipoOrganizacion?: string;
  rubro?: { emoji: string; label: string };
  branding?: {
    logoUrl?: string;
    primaryColor?: string;
    nombreComercial?: string;
  };
};

export type CuposDia = {
  dia: string;
  cupos: string[];
  ocupados: string[];
};

const BASE = '/api/citas/v1/public/citas';

export async function infoClinica(tenantId: string): Promise<ClinicaPublicaInfo> {
  const r = await fetch(`${BASE}/${encodeURIComponent(tenantId)}/info`, {
    headers: { Accept: 'application/json' },
  });
  if (!r.ok) throw new Error(r.status === 404 ? 'Clinica no encontrada' : `Error ${r.status}`);
  return r.json();
}

export async function cuposDia(tenantId: string, dia: string): Promise<CuposDia> {
  const r = await fetch(
    `${BASE}/${encodeURIComponent(tenantId)}/cupos?dia=${encodeURIComponent(dia)}`,
    { headers: { Accept: 'application/json' } },
  );
  if (!r.ok) {
    const j = await r.json().catch(() => ({}));
    throw new Error((j as { error?: string }).error ?? `Error ${r.status}`);
  }
  return r.json();
}

export type AgendarPayload = {
  pacienteNombre: string;
  telefono: string;
  fechaHora: string;
  profesional?: string;
  motivo?: string;
};

export async function agendarCita(tenantId: string, payload: AgendarPayload): Promise<{ id: string; mensaje: string }> {
  const r = await fetch(`${BASE}/${encodeURIComponent(tenantId)}/agendar`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(payload),
  });
  const j = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error((j as { error?: string }).error ?? `Error ${r.status}`);
  return j as { id: string; mensaje: string };
}

export function urlAgendarPublico(tenantId: string): string {
  const origin = typeof location !== 'undefined' ? location.origin : 'https://app.toscana-clinica.com';
  return `${origin}/agendar/${encodeURIComponent(tenantId)}`;
}

export function hoyIso(): string {
  return new Date().toISOString().slice(0, 10);
}

export function mananaIso(): string {
  const d = new Date();
  d.setDate(d.getDate() + 1);
  return d.toISOString().slice(0, 10);
}

export function pasadoMananaIso(): string {
  const d = new Date();
  d.setDate(d.getDate() + 2);
  return d.toISOString().slice(0, 10);
}

export function isoLocalDateTime(dia: string, hora: string): string {
  return new Date(`${dia}T${hora}:00-06:00`).toISOString();
}

/** Gemini AI chat */
export async function geminiChat(
  tenantId: string,
  message: string,
  history: Array<{ who: string; text: string }>,
): Promise<{ reply: string; fromAI: boolean; data?: Record<string, string> }> {
  const res = await fetch(`/api/citas/v1/public/gemini/chat?tid=${tenantId}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ message, history }),
  });
  if (!res.ok) throw new Error(`Gemini error ${res.status}`);
  return res.json();
}
